<template lang="pug">
base-nav.navbar-top.navbar-dark(
  :show-toggle-button="false",
  logo="favicon.png",
  expand
)
  form.navbar-search.navbar-search-dark.form-inline.mr-3.d-none.d-md-flex.ml-lg-auto
    ul.navbar-nav.align-items-center.d-none.d-md-flex
      //- CHANGE LANGUAJE
      li.nav-item.dropdown
        base-dropdown.pr-0
          .media.align-items-center(slot="title")
            .media-body.ml-2
              img.mr-2(:src="flag.img", width="20", height="13")
              span.mb-0.text-sm.text-white.font-weight-bold(
                style={ cursor: 'pointer' }
              ) {{ flag.name }}

          template
            a.dropdown-item(
              v-for="(vm, i) in langs",
              :key="i",
              @click="changeLang(vm.path)"
            )
              img.mr-1(:src="vm.icon", width="20", height="13")
              span.table-text {{ vm.name }}
  ul.navbar-nav.align-items-center.d-none.d-md-flex
    li.nav-item.dropdown
      base-dropdown.pr-0
        .media.align-items-center(slot="title")
          span.avatar.avatar-sm.rounded-circle.bg-primary {{ avatar }}
          .media-body.ml-2.d-none.d-md-block
            span.mb-0.text-sm.text-white.font-weight-bold(
              style={ cursor: 'pointer' }
            ) {{ user.name }} {{ user.lastname }}
        template
          router-link.dropdown-item.table-text(to="/profile")
            i.ni.ni-single-02
            span {{ $t('my_profile') }}
          .dropdown-item.table-text(@click="$refs.modalsReferrals.show()")
            i.ri-vip-crown-2-line
            span {{ $t('my_referrals') }}
          .dropdown-divider

          .dropdown-item.table-text(@click="logout")
            i.ni.ni-user-run
            span {{ $t('logout') }}
    li.nav-item
      .h2.ml-3.mt-3.text-white(
        v-b-tooltip.hover,
        :title="darkMode ? 'Mode Light' : 'Mode Dark'"
      )
        i(
          @click="darkMode = !darkMode",
          :class="darkMode ? 'ri-sun-fill' : 'ri-moon-fill'"
        )
    ModalReferrals(ref="modalsReferrals")
</template>
<script>
import ModalReferrals from "../views/Profile/MyReferralsModal.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    ModalReferrals,
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: "",
      darkMode: false,
    };
  },
  watch: {
    darkMode: function () {
      let htmlElement = document.documentElement;
      if (this.darkMode) {
        localStorage.setItem("theme", "dark");
        htmlElement.setAttribute("theme", "dark");
      } else {
        localStorage.setItem("theme", "light");
        htmlElement.setAttribute("theme", "light");
      }
    },
  },
  mounted() {
    document.title = "M2M";

    // set 'app-background' class to body tag
    let bodyElement = document.body;
    bodyElement.classList.add("app-background");

    // check for active theme
    let htmlElement = document.documentElement;
    let theme = localStorage.getItem("theme");

    if (theme === "dark") {
      htmlElement.setAttribute("theme", "dark");
      this.darkMode = true;
    } else {
      htmlElement.setAttribute("theme", "light");
      this.darkMode = false;
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    async logout() {
      const res = await this.$store.dispatch("logout");
      if (res.status === 202) {
        this.$router.push("/login");
      }
    },
    async changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      this.$toast.success(this.$t("language_changed"), {
        position: "top-right",
      });
    },
    darkThemeSwitch() {
      const res = localStorage.getItem("theme");
      if (res === "dark") {
        this.$store.commit("SET_THEME", "light");
        localStorage.setItem("theme", "light");
      } else {
        this.$store.commit("SET_THEME", "dark");
        localStorage.setItem("theme", "dark");
      }
      this.darkTheme = !this.darkTheme;
    },
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
    avatar() {
      if (this.user) {
        return `${this.user.name.charAt()}${this.user.lastname.charAt()}`;
      }
    },
    flag() {
      const locale = this.$i18n.locale;
      if (locale === "en")
        return { img: "/img/flags/en.png", name: this.$t("english") };
      else if (locale === "es")
        return { img: "/img/flags/es.jpg", name: this.$t("spanish") };
      else if (locale === "de")
        return { img: "img/flags/de.png", name: this.$t("germany") };
      else return { img: "/img/flags/en.png", name: this.$t("english") };
    },
    langs() {
      return [
        { icon: "/img/flags/en.png", path: "en", name: this.$t("english") },
        { icon: "/img/flags/es.jpg", path: "es", name: this.$t("spanish") },
        { icon: "/img/flags/de.png", path: "de", name: this.$t("germany") },
      ];
    },
  },
};
</script>
